import { useState } from "react";
import { useContract } from "./useContract";
import { UpdateAdditionalIProps } from "../model/schema";

interface MutateOptions {
  onSuccess?: (data: any) => void;
  onError?: (error: any) => void;
}

export const useUpdateAdditional = () => {
  const { updateAdditional } = useContract();
  const [data, setData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);

  const mutate = async (
    { data, id }: UpdateAdditionalIProps,
    options?: MutateOptions
  ) => {
    setIsLoading(true);
    setError(null);
    setIsSuccess(false);
    try {
      const result = await updateAdditional({ data, id });
      if (result.data) {
        setData(result.data);
        setIsSuccess(true);
        options?.onSuccess?.(result.data);
      } else {
        setError("Не удалось обновить доп. соглашение");
        options?.onError?.("Не удалось обновить доп. соглашение");
      }
    } catch (error) {
      setError("Не удалось обновить доп. соглашение");
      options?.onError?.("Не удалось обновить доп. соглашение");
    } finally {
      setIsLoading(false);
    }
  };
  return { mutate, isLoading, error, isSuccess, data };
};
